import React, { useState } from 'react';
import { usePathname } from 'next/navigation';
import { Category, Product } from 'shared/types/product';
import { useFormat } from 'helpers/hooks/useFormat';
import { getModuleBackgroundStyle } from 'helpers/utils/helperFunctions';
import { useProduct } from 'frontastic';
import Image from 'frontastic/lib/image';

interface FaqCollectionItem {
  question?: string;
  answer?: string;
}
interface ImageForTeaser {
  title?: string;
  url?: string;
  width?: number;
  height?: number;
}

export interface ContactMultiTeaserProps {
  dataProps?: {
    modulePlaceholder?: {
      components?: {
        faqsCollection?: {
          items?: FaqCollectionItem[];
        };
      };
      description?: string;
      headline?: string;
      headlineType?: string;
      buttonText?: string;
      buttonLink?: string;
      internalName?: string;
      faqImage?: ImageForTeaser;
    };
    productFaqData?: {
      faq_content_data?: {
        faqCollection?: {
          items?: FaqCollectionItem[];
        };
      };
    };
    productCategories?: Category[];
  };
  indexing: number;
}

const ListingSpecificModule: React.FC<ContactMultiTeaserProps> = ({ dataProps, indexing }) => {
  const faqsList = dataProps?.productFaqData?.faq_content_data?.faqCollection?.items || [];
  const [isOpenFaq, setIsOpenFaq] = useState<boolean[]>(Array(faqsList.length).fill(true));
  const { formatMessage: formatCommonMessage } = useFormat({ name: 'common' });
  const { categories } = useProduct();
  const [visibleCount, setVisibleCount] = useState<number>(3);
  const getCategoryId = dataProps?.productCategories?.[0]?.categoryId;
  const getProductCategory = categories?.find((cat) => cat?.categoryId === getCategoryId);
  const getPathCategoryName = getProductCategory?.path?.split('/')?.[1];
  const currentBackgroundStyle = getModuleBackgroundStyle();
  if (faqsList?.length === 0) {
    return null;
  }
  const mathcedCategory = categories?.find(
    (category) => category.slug?.toLowerCase() === getPathCategoryName?.toLowerCase(),
  );

  const handleShowMore = () => {
    setVisibleCount(faqsList?.length);
  };
  const faqButton = dataProps?.modulePlaceholder?.buttonText;

  return (
    <div
      className={`mx-auto h-fit max-w-screen-xl bg-cover px-10 pb-30 pt-20 lg:px-25 ${
        indexing % 2 == 0 ? currentBackgroundStyle : ''
      }`}
    >
      <div className="flex gap-30 pb-50">
        <div>
          <Image className="h-85 w-auto rounded object-cover" src={mathcedCategory?.category_image_url} />
        </div>
        <div className="flex flex-col">
          <div className="font-calibri text-18 font-extrabold">
            {dataProps?.modulePlaceholder?.headline} - {mathcedCategory?.name}
          </div>
          <div className="font-calibri text-12 font-bold text-blueTheme-black">
            {dataProps?.modulePlaceholder?.description}
          </div>
        </div>
      </div>
      <div>
        {faqsList &&
          faqsList?.slice(0, visibleCount)?.map((faq: FaqCollectionItem, index: number) => {
            return (
              <div
                key={index}
                className="cursor-pointer border border-blueTheme-grayDark p-20"
                onClick={() => {
                  setIsOpenFaq((prevState) => prevState.map((value, vIndex) => (index === vIndex ? !value : value)));
                }}
              >
                <div className="border-b font-calibri text-18 font-bold text-blueTheme-black">{faq.question}</div>

                {isOpenFaq[index] && (
                  <div
                    className="mt-5 font-calibri text-14 text-blueTheme-black"
                    dangerouslySetInnerHTML={{
                      __html: faq.answer as string,
                    }}
                  />
                )}
              </div>
            );
          })}
      </div>

      {faqsList?.length > visibleCount && (
        <div className="mt-20 flex justify-center">
          <button
            className="mx-auto w-full max-w-3xl rounded-md border border-solid border-gray-800 bg-white p-5 text-14 font-bold"
            onClick={handleShowMore}
          >
            {faqButton}
          </button>
        </div>
      )}
    </div>
  );
};

export default ListingSpecificModule;
